/* eslint-disable extra-rules/no-commented-out-code */
/* eslint-disable max-lines */
import {
  getCategoryBasedProducts,
  getSEOTokenJSON,
  loadCategoryPageSeoData,
} from '@tcp/core/src/components/features/browse/CategoryListingPage/container/CategoryListingPage.actions';
import has from 'lodash/has';
import PromoCombinationAbstractor from '@tcp/core/src/services/abstractors/promoCombination';
import Espot from '@tcp/core/src/components/common/molecules/Espot';
import {
  getNavigationTree,
  getplpHlpAplpChecks,
  isSameCategory,
  pathToQuery,
} from '@tcp/core/src/components/features/browse/CategoryListingPage/container/CategoryListingPage.utils';
import {
  PlpBreadCrumb,
  PlpGrid,
  PlpGridColumn,
  TotalProductsCountWrapper,
  ProductsCountWrapper,
} from '@tcp/core/src/components/features/browse/CategoryListingPage/styles/PaginatedPage.style';
import BuyItAgainDynamicStore from '@tcp/core/src/components/features/account/BuyItAgain/container/BuyItAgainDynamicStore';
import FixedBreadCrumbs from '@tcp/core/src/components/features/browse/ProductListing/molecules/FixedBreadCrumbs/views';
import NewLoadedProductsCount from '@tcp/core/src/components/features/browse/ProductListing/molecules/NewLoadedProductsCount/views/NewLoadedProductsCount.view';
import { SEO_DATA, SEO_PAGE_DIRECTIVE } from '@tcp/core/src/reduxStore/constants';
import { loadModulesData, loadPromoCombinationData } from '@tcp/core/src/reduxStore/actions';
import ProductAbstractor from '@tcp/core/src/services/abstractors/productListing';
import { isShopThisStoreModeOn } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import {
  getSessionStorage,
  removeSessionStorage,
  getSiteId,
  isClient,
  parseBoolean,
  getViewportInfo,
} from '@tcp/core/src/utils';
import { getAPIConfig, capitalizeWords } from '@tcp/core/src/utils/utils';
import SEOTags from '@tcp/web/src/components/common/atoms/SEOTags/SEOTags';
import dynamic from 'next/dynamic';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import useHasMounted from '@tcp/core/src/hooks/useHasMounted';
import { slpSubLabels, SLP_SUB_LABELS } from '@tcp/core/src/utils/labels/browse/SLP.labels';
import { PLPLabels } from '@tcp/core/src/utils/labels/browse/PLP.labels';
import outfitCarousel from '@tcp/core/src/components/common/molecules/OutfitCarouselModule';
import moduleX from '@tcp/core/src/components/common/molecules/ModuleX';
import moduleA from '@tcp/core/src/components/common/molecules/ModuleA';
// eslint-disable-next-line camelcase
import module_container from '@tcp/core/src/components/common/molecules/ModuleContainer';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { getSelectedPageProductRange } from '@tcp/core/src/components/features/browse/SearchDetail/container/SearchDetail.util';
import { mapDispatchToProps, mapStateToProps } from './clpReduxProps';
import {
  getcategoryID,
  getSeoTagConfig,
  shouldRenderBlank,
  shouldRenderSkeleton,
  shouldRenderSkeletonNew,
  replaceWord,
  getCurrentPageNumber,
  isFacetedNavigationNoIndexApplicable,
} from './clpContainerHelper';
import { ClpDefaultProps, ClpPropTypes } from './clpContainerPropTypes';

const BundleTrackerContainer = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "bundle-tracker-container" */ '@tcp/core/src/components/common/atoms/BundleTracker/container/BundleTracker.container'
    ),
  { ssr: false }
);

const instanceProductListing = new ProductAbstractor();

const BackToTop = dynamic(() => import('@tcp/core/src/components/common/atoms/BackToTop'), {
  ssr: false,
});

// SYTE Vendor Script
const SyteVendorScript = dynamic(() => import('../../../common/vendors/Syte/Syte'));

const PaginatedPageContainer = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "paginated-category" */ '@tcp/core/src/components/features/browse/CategoryListingPage/container/PaginatedPage.container'
  )
);

const HorizontalCategoryContainer = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "horizontal-category" */ '@tcp/core/src/components/features/browse/HorizontalCategory/container/HorizontalCategory.container'
  )
);

const AlternatePLPCategoryContainer = dynamic(() =>
  import(
    /* webpackChunkName: "alt-plp-ccontainer" */ '@tcp/core/src/components/features/browse/AlternatePlp/container/AlternatePlp.container'
  )
);

const GlobalRtpsModal = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "global-rtps-modal" */ '@tcp/core/src/components/common/molecules/GlobalRtpsModal/container/GlobalRtpsModal.container'
    ),
  { ssr: false }
);

const OutfitListingContainer = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "outfit-listing" */ '@tcp/core/src/components/features/browse/OutfitListing/container'
  )
);

const divisionTabs = dynamic(() =>
  import(
    /* webpackChunkName: "divisionTabs" */ '@tcp/core/src/components/common/molecules/DivisionTabModule'
  )
);
const jeans = dynamic(() =>
  import(/* webpackChunkName: "jeans" */ '@tcp/core/src/components/common/molecules/JeansModule')
);
const essentials = dynamic(() =>
  import(
    /* webpackChunkName: "essentials" */ '@tcp/core/src/components/features/browse/ProductListing/organisms/EssentialShop'
  )
);

const moduleDynamic = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "moduleDynamic" */ '@tcp/core/src/components/common/molecules/ModuleDynamic'
  )
);
const moduleD = dynamic(() =>
  import(/* webpackChunkName: "moduleD" */ '@tcp/core/src/components/common/molecules/ModuleD')
);
const moduleJ = dynamic(() =>
  import(/* webpackChunkName: "moduleJ" */ '@tcp/core/src/components/common/molecules/ModuleJ')
);
const moduleTabbedCarousel = dynamic(() =>
  import(
    /* webpackChunkName: "moduleTabbedCarousel" */ '@tcp/core/src/components/common/molecules/ModuleTabbedCarousel'
  )
);

const shouldShowTotalProductCount = ({
  isDesktop,
  isMountedSortAndOneHrFilterRedesignEnabled,
  shouldHideLeftNavigation,
}) => {
  return isDesktop
    ? isMountedSortAndOneHrFilterRedesignEnabled && shouldHideLeftNavigation
    : isMountedSortAndOneHrFilterRedesignEnabled;
};

const dynamicPromoModules = {
  Espot,
  divisionTabs,
  outfitCarousel,
  jeans,
  moduleX,
  moduleA,
  essentials,
  moduleDynamic,
  // eslint-disable-next-line camelcase
  module_container,
  moduleD,
  moduleJ,
  moduleTabbedCarousel,
};

const renderBreadCrumbs = ({
  processedBreadCrumbs,
  isABTestForStickyFilter,
  totalProductsCount,
  hidePlpGridAndFilters,
  shouldHideLeftNavigation,
  from,
  till,
  showTotalProductCount,
}) => {
  const slpLabels = getLabelFromCopyOrFromTranslation(SLP_SUB_LABELS, slpSubLabels);
  const ItemLabel = renderLabel(slpLabels.lbl_item, 'lbl_item');
  const ItemsLabel = renderLabel(slpLabels.lbl_items, 'lbl_items');
  const separationChar = showTotalProductCount ? '/' : '>';
  return (
    !hidePlpGridAndFilters && (
      <PlpGrid
        alignCenterAndAddSpaceBetween={shouldHideLeftNavigation || showTotalProductCount}
        showTotalProductCount={showTotalProductCount}
      >
        <PlpGridColumn breadcrumbs>
          {processedBreadCrumbs.length ? (
            <PlpBreadCrumb showTotalProductCount={showTotalProductCount}>
              <FixedBreadCrumbs crumbs={processedBreadCrumbs} separationChar={separationChar} />
            </PlpBreadCrumb>
          ) : null}
        </PlpGridColumn>
        {isABTestForStickyFilter && (
          <PlpGridColumn alignCenter>
            <NewLoadedProductsCount
              totalProductsCount={totalProductsCount}
              breadCrumbs={processedBreadCrumbs}
            />
          </PlpGridColumn>
        )}
        {(shouldHideLeftNavigation || showTotalProductCount) && totalProductsCount > 0 && (
          <ProductsCountWrapper showTotalProductCount={showTotalProductCount}>
            <span className="current-page-product-range">{`${from}-${till}`}</span>
            <span className="products-count-divider">|</span>
            <TotalProductsCountWrapper>
              <span className="items-count">{totalProductsCount}</span>
              <span className="items-label">{totalProductsCount > 1 ? ItemsLabel : ItemLabel}</span>
            </TotalProductsCountWrapper>
          </ProductsCountWrapper>
        )}
      </PlpGrid>
    )
  );
};

const getIsBackFromPdp = (pathName, viaBreadCrumb) => {
  const [pathNameWithoutQuery, queryParam = ''] = pathName.split('?');
  let sameQueryParam = true;
  const lastPageQueryParam = getSessionStorage('LAST_PAGE_QUERY_PARAM');
  if (lastPageQueryParam) {
    sameQueryParam = lastPageQueryParam === queryParam;
  }
  return (
    window.isPdpLinkClicked &&
    getSessionStorage('LAST_PAGE_PATH') === pathNameWithoutQuery &&
    viaBreadCrumb !== 'true' &&
    sameQueryParam
  );
};

const colorPatternReplacement = (param) => {
  const {
    isPLPFacetedNavigationEnabled,
    seoTitle,
    seoMetaDesc,
    filterCount,
    filterCountFromURL,
    filterValue,
  } = param;
  let updatedSeoTitle = replaceWord(seoTitle, '<color> ', '');
  updatedSeoTitle = replaceWord(updatedSeoTitle, '<c_color> ', '');
  let updatedSeoMetaDesc = replaceWord(seoMetaDesc, '<color> ', '');
  updatedSeoMetaDesc = replaceWord(updatedSeoMetaDesc, '<c_color> ', '');
  if (
    isPLPFacetedNavigationEnabled &&
    (filterCount === 1 || filterCountFromURL === 1) &&
    filterValue
  ) {
    updatedSeoTitle = replaceWord(seoTitle, '<color>', filterValue.toLowerCase());
    updatedSeoTitle = replaceWord(updatedSeoTitle, '<c_color>', capitalizeWords(filterValue));
    updatedSeoMetaDesc = replaceWord(seoMetaDesc, '<color>', filterValue.toLowerCase());
    updatedSeoMetaDesc = replaceWord(updatedSeoMetaDesc, '<c_color>', capitalizeWords(filterValue));
  }
  return { updatedSeoTitle, updatedSeoMetaDesc };
};

const sizePatternReplacement = (param) => {
  const {
    isPLPFacetedNavigationEnabled,
    seoTitle,
    seoMetaDesc,
    filterCount,
    filterCountFromURL,
    filterValue,
    sizeLabel,
  } = param;
  const lsl = sizeLabel?.toLowerCase();
  let updatedSeoTitle = replaceWord(seoTitle, '<size> ', '');
  updatedSeoTitle = replaceWord(updatedSeoTitle, '<s_size> ', '');
  let updatedSeoMetaDesc = replaceWord(seoMetaDesc, '<size> ', '');
  updatedSeoMetaDesc = replaceWord(updatedSeoMetaDesc, '<s_size> ', '');
  if (
    isPLPFacetedNavigationEnabled &&
    (filterCount === 1 || filterCountFromURL === 1) &&
    filterValue
  ) {
    updatedSeoTitle = replaceWord(seoTitle, '<size>', `${lsl} ${filterValue}`);
    updatedSeoTitle = replaceWord(updatedSeoTitle, ' <s_size>', `: ${sizeLabel} ${filterValue}`);
    updatedSeoMetaDesc = replaceWord(seoMetaDesc, '<size>', `${lsl} ${filterValue}`);
    updatedSeoMetaDesc = replaceWord(
      updatedSeoMetaDesc,
      '<s_size>',
      ` : ${sizeLabel} ${filterValue}`
    );
  }
  return { updatedSeoTitle, updatedSeoMetaDesc };
};

const getSEOPageNumberStr = (currentPageNumber) =>
  currentPageNumber > 1 ? ` | ${currentPageNumber}` : '';

const getUpdatedCanonical = ({ currentPageNumber, totalProductsCount, canonical, filterCount }) => {
  if (!canonical) {
    return canonical;
  }
  const pageStr = currentPageNumber > 1 ? `?page=${currentPageNumber}` : '';
  let updatedCanonical = canonical;

  // Adding this check as we only want to update the canonical to their parent category page when we have 3 or less products. For filterCount greater than 1, we delete the canonical tag.
  if (totalProductsCount < 4 && filterCount === 1) {
    const pathSegments = canonical.split('/c/');
    if (pathSegments.length > 1) {
      const subPathSegments = pathSegments[1].split('/');
      if (subPathSegments.length > 1) {
        subPathSegments.pop();
        updatedCanonical = `${pathSegments[0]}/c/${subPathSegments.join('/')}`;
      }
    }
  }
  updatedCanonical = `${updatedCanonical}${pageStr}`;
  return updatedCanonical;
};

const getSEOTags = ({
  pageId,
  paginatedProducts,
  seoTitle,
  seoMetaDesc,
  canonicalUrl,
  router,
  genericCarouselData,
  isPLPCarouselEnabled,
  isPLPFacetedNavigationEnabled,
  appliedFilterIdsAndLength = {},
  totalProductsCount,
  appliedFilters,
  pathName,
  isNewSEOHreflangLinkEnabled,
  seoTokenList,
  currentPageNumber,
  seoPageDirective,
}) => {
  let updatedSeo = {};
  const {
    filterCount,
    filterCountFromURL,
    singleColorFilterValue = '',
    singleSizeFilterValue = '',
  } = appliedFilterIdsAndLength;

  const sizeLabel = getLabelFromCopyOrFromTranslation('PLP.PLP_sort_filter.lbl_size', PLPLabels);

  updatedSeo = colorPatternReplacement({
    isPLPFacetedNavigationEnabled,
    seoTitle,
    seoMetaDesc,
    filterCount,
    filterCountFromURL,
    filterValue: singleColorFilterValue,
  });

  const { updatedSeoTitle: title, updatedSeoMetaDesc: desc } = updatedSeo || {};

  updatedSeo = sizePatternReplacement({
    isPLPFacetedNavigationEnabled,
    seoTitle: title,
    seoMetaDesc: desc,
    filterCount,
    filterCountFromURL,
    filterValue: singleSizeFilterValue,
    sizeLabel,
  });

  const { updatedSeoTitle, updatedSeoMetaDesc } = updatedSeo || {};
  const { seoConfig } = getSeoTagConfig({
    pageId,
    paginatedProducts,
    seoTitle: updatedSeoTitle,
    seoMetaDesc: updatedSeoMetaDesc,
    canonicalUrl,
    router,
    genericCarouselData,
    isPLPCarouselEnabled,
    isNewSEOHreflangLinkEnabled,
    seoTokenList,
    seoPageDirective,
  });
  if (seoConfig) {
    if (has(seoConfig, 'canonical')) {
      seoConfig.canonical = getUpdatedCanonical({
        currentPageNumber,
        totalProductsCount,
        canonical: seoConfig.canonical,
        filterCount,
      });
    }
    if (has(seoConfig, 'title')) {
      const pageStr = getSEOPageNumberStr(currentPageNumber);
      seoConfig.title = `${seoConfig.title}${pageStr}`;
    }
    if (seoPageDirective && seoPageDirective !== '') {
      const directiveSet = new Set(
        seoPageDirective.split(',').map((dir) => dir.trim().toUpperCase())
      );

      seoConfig.noindex = directiveSet.has(SEO_PAGE_DIRECTIVE.NO_INDEX);
      seoConfig.nofollow = directiveSet.has(SEO_PAGE_DIRECTIVE.NO_FOLLOW);
    }

    if (
      isFacetedNavigationNoIndexApplicable({
        isPLPFacetedNavigationEnabled,
        filterCount,
        appliedFilters,
        pathName,
      })
    ) {
      seoConfig.nofollow = true;
      seoConfig.noindex = true;
      if (has(seoConfig, 'canonical')) delete seoConfig.canonical;
    }

    return <SEOTags seoConfig={seoConfig} pageId={pageId} />;
  }
  return null;
};
const getIsNavChanged = (initialCidRef, initialCallRef, cid) => {
  return initialCidRef.current !== cid || !initialCallRef.current;
};

function getIsValidUrl({ pathName }) {
  const path = pathName?.split('?')[0] || '';
  const segments = path.split('/c/')[1]?.split('/').filter(Boolean) || [];

  // Return true for 0 or 1 segments
  if (segments.length <= 1) return true;
  if (segments.length > 3) return false;

  // Validate the 2nd and 3rd segments if they exist
  const isValidSegment = (segment) => segment?.startsWith('color_') || segment?.startsWith('size_');

  if (segments.length >= 2 && !isValidSegment(segments[1])) return false;
  if (segments.length === 3 && !isValidSegment(segments[2])) return false;

  return true;
}

/**
 * This container is shared with paginated page view and Horizontal Category container
 */

// eslint-disable-next-line complexity
const CategoryListingPage = ({
  getCategoryBasedProductsActn,
  totalProductsCount,
  paginatedProducts,
  onQuickViewOpenClick,
  onAddItemToFavorites,
  onSetLastDeletedItemIdAction,
  wishListData,
  isShortImage,
  isABTestForStickyFilter, // Check if this ABtest is needed
  processedBreadCrumbs,
  onFavtLoad,
  isLoggedIn,
  loadSeoDetails,
  isHorizontalPlpEnabled,
  seoTitle,
  seoMetaDesc,
  canonicalUrl,
  router,
  isBundleTrackerEnabled,
  isTrackerOpen,
  promotionsData,
  toggleTrackerAction,
  trackClickBundles,
  trackPageLoadSearchRedirect,
  getPaginatedProductsActn,
  fetchInitialProductsWithFacets,
  seoHeaderCopy,
  topPromosContent,
  categoryHasCMSPromoCombinations,
  trackWishListClick,
  isInitialCall,
  isSyteEnabled,
  navigationData,
  longDescription,
  isOutfitPLPEnabled,
  recordsPerPage,
  isPLPCategoryPillsEnabled,
  isAlternatePlpEnabled,
  isBIAABCustomVariableEnabled,
  getBIABagPageProducts,
  addToBagEcom,
  isOneClickATCEnabled,
  setFromHplpFlag,
  isFromHplp,
  favAddRemoveLoadingState,
  isGuestFavEnabled,
  getHomePageLayout,
  layouts,
  isSeoHeaderCopyLoaded,
  setIsProductLoadingActn,
  isProductLoadingFlag,
  genericCarouselData,
  isPLPCarouselEnabled,
  isFacetedNavigationEnabled,
  seoFacetedNavigationConfig,
  appliedFilterIdsAndLength,
  isCleanUrlForSizeEnabled,
  filterMaps,
  collectionOutfitCatID,
  appliedFilters,
  isNewSEOHreflangLinkEnabled,
  seoTokenList,
  getSEOTokenJSONAction,
  hidePlpGridAndFilters,
  isQuickFiltersModuleEnabled,
  seoPageDirective,
  isHideLeftNavigationOnPLPEnabled,
  currentPageNumber,
  selectedPageProductCount,
  isSortAndOneHrFilterRedesignEnabled,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const {
    query: { cid: cidWithoutTrim, viaBreadCrumb },
    asPath,
  } = router || {};
  const cid = cidWithoutTrim?.trim();
  const [hideFilters, setHideFilters] = useState(true);
  const initialCallRef = useRef(false);
  const initialCidRef = useRef(cid);
  const isUserLoggedIn = useRef(isLoggedIn);
  const pathName = asPath?.trim();
  const [pathNameWithoutQuery, queryParams] = pathName.split('?');
  const prevPathRef = useRef(pathNameWithoutQuery);
  const clothingSizeMap = filterMaps?.v_clothingsize_uFilter;
  let tmpQueryParams = queryParams;
  if (isFacetedNavigationEnabled) {
    const pathQuery = pathToQuery(pathNameWithoutQuery, seoFacetedNavigationConfig, {
      isCleanUrlForSizeEnabled,
      clothingSizeMap,
    });
    tmpQueryParams = `${pathQuery}${tmpQueryParams ? `&${tmpQueryParams}` : ''}`;
  }
  const urlParams = new URLSearchParams(tmpQueryParams);
  const pageNumber = urlParams.get('page') || 1;
  urlParams.delete('page');
  const queryWithoutPageNo = (urlParams || '').toString();
  const initialQueryRef = useRef(queryWithoutPageNo);
  const outfitPath = pathName.substring(pathName.lastIndexOf('/') + 1);
  const hasMounted = useHasMounted();
  const isSubCategoryFilterApplied =
    urlParams.has('filter_cat_grp') && urlParams.get('filter_cat_grp')?.trim() !== '';

  useEffect(() => {
    if (initialCallRef.current && totalProductsCount < 1 && processedBreadCrumbs?.length < 2) {
      getCategoryBasedProductsActn({
        cid,
        pathName,
        recordsPerPage,
        currentPageNumber: getCurrentPageNumber(pageNumber),
        isInitialCall,
        isInitialClientCall: !initialCallRef.current,
        skipCategoryCall: !getIsValidUrl({
          isSeoFacetedNavigationEnabled: isFacetedNavigationEnabled,
          pathName,
        }),
      });
    }
  }, [navigationData]);

  useEffect(() => {
    const apiConfig = getAPIConfig();
    const { loadHomePageDataEnabled } = apiConfig;
    if (loadHomePageDataEnabled && !layouts.home) getHomePageLayout(apiConfig);
  }, []);
  useEffect(() => {
    if (pathNameWithoutQuery === window?.location?.pathname) {
      // For initial ssr call or back from PDP or navigating between different categories
      if (getIsNavChanged(initialCidRef, initialCallRef, cid)) {
        const isBackFromPdp = getIsBackFromPdp(pathName, viaBreadCrumb);
        if (!isBackFromPdp && cid !== undefined) {
          if (!isSameCategory(asPath, processedBreadCrumbs, isFacetedNavigationEnabled)) {
            setIsProductLoadingActn(true);
          }
          getCategoryBasedProductsActn({
            cid,
            pathName,
            recordsPerPage,
            currentPageNumber: getCurrentPageNumber(pageNumber),
            isInitialCall,
            isInitialClientCall: !initialCallRef.current,
            skipCategoryCall: !getIsValidUrl({
              pathName,
            }),
            isQuickFiltersModuleEnabled,
            isSubCategoryFilter: parseBoolean(isSubCategoryFilterApplied),
          });
        }
        if (window.isPdpLinkClicked) {
          window.isPdpLinkClicked = false;
        }
      } else if (initialQueryRef.current !== queryWithoutPageNo) {
        // For filter or sort change and also to handle change in filter using back/forward button
        fetchInitialProductsWithFacets({
          pathName,
          recordsPerPage,
          currentPageNumber: getCurrentPageNumber(pageNumber),
          isSortOrFilter: true,
          cid,
          isFromFilters: true,
          isSubCategoryFilter: parseBoolean(isSubCategoryFilterApplied),
        });
      } else {
        // For pagination in the same category
        getPaginatedProductsActn({ currentPageNumber: getCurrentPageNumber(pageNumber) });
      }
      if (!isShopThisStoreModeOn()) {
        initialCidRef.current = cid;
        initialCallRef.current = true;
        initialQueryRef.current = queryWithoutPageNo;
      }
    }
  }, [pathName]);

  useEffect(() => {
    if (pathNameWithoutQuery === window?.location?.pathname) {
      const lastPath = getSessionStorage('LAST_PAGE_PATH');
      if (
        prevPathRef.current !== pathNameWithoutQuery ||
        (lastPath !== null &&
          lastPath !== pathNameWithoutQuery &&
          topPromosContent &&
          topPromosContent.length > 0)
      ) {
        prevPathRef.current = pathNameWithoutQuery;
        removeSessionStorage('LAST_PAGE_PATH');
      }
    }
  }, [pathName]);

  const handleonAddItemToFavorites = async (payload) => {
    onAddItemToFavorites(payload);
  };

  useEffect(() => {
    if (
      isUserLoggedIn.current !== isLoggedIn ||
      (!isLoggedIn &&
        isGuestFavEnabled &&
        !wishListData?.id &&
        getSessionStorage(`defaultWishlistid${getSiteId()}`) !== null)
    ) {
      onFavtLoad(true);
    }
    isUserLoggedIn.current = isLoggedIn;
    const fetchBIAData = async () => {
      await BuyItAgainDynamicStore();
    };
    if (isBIAABCustomVariableEnabled && isLoggedIn) {
      fetchBIAData();
      getBIABagPageProducts();
    }
  }, [isLoggedIn, isGuestFavEnabled, wishListData]);

  useEffect(() => {
    if (cid) {
      const apiConfig = getAPIConfig();
      const payload = {
        apiConfig,
        page: cid,
        isCategoryPage: true,
      };
      getSEOTokenJSONAction();
      loadSeoDetails({ module: SEO_DATA.categorySeoData, ...payload });
    }
  }, [cid, pathName]);

  const navTree = useMemo(() => {
    return getNavigationTree(navigationData, pathName);
  }, [navigationData, pathName]);
  const Syte = isSyteEnabled ? SyteVendorScript : () => null;
  const outfitAsPath = pathName.substring(pathName.lastIndexOf('/') + 1);
  const plpHlpAplpChecks = getplpHlpAplpChecks(
    processedBreadCrumbs,
    navigationData,
    navTree,
    isAlternatePlpEnabled,
    isHorizontalPlpEnabled,
    isOutfitPLPEnabled,
    false,
    collectionOutfitCatID
  );
  const { checkOutfit, sbcTypeValue } = plpHlpAplpChecks;
  if (shouldRenderBlank(asPath, processedBreadCrumbs, isFacetedNavigationEnabled)) return null;

  const shouldRenderSkeletonTmp = isFacetedNavigationEnabled
    ? shouldRenderSkeletonNew(asPath, processedBreadCrumbs, isFacetedNavigationEnabled)
    : shouldRenderSkeleton(asPath, processedBreadCrumbs);

  const shouldRenderSkeletonComponent = isProductLoadingFlag || shouldRenderSkeletonTmp;
  const isPaginatedPlp = !isHorizontalPlpEnabled && !isAlternatePlpEnabled && !checkOutfit;
  const isPLPFacetedNavigationEnabled = isPaginatedPlp && isFacetedNavigationEnabled;

  const { isDesktop } = getViewportInfo() || {};
  const isMountedCheck = router?.isSsr ? hasMounted : true;
  const isMountedHideLeftNavigationOnPLPEnabled =
    isMountedCheck && isHideLeftNavigationOnPLPEnabled && isDesktop && !hidePlpGridAndFilters;
  const shouldHideLeftNavigation =
    isMountedHideLeftNavigationOnPLPEnabled && isPaginatedPlp && hideFilters;

  const isPLPSortAndOneHrFilterRedesignEnabled =
    isPaginatedPlp && isSortAndOneHrFilterRedesignEnabled && !hidePlpGridAndFilters;
  const isMountedSortAndOneHrFilterRedesignEnabled =
    isMountedCheck && isPLPSortAndOneHrFilterRedesignEnabled;
  const showTotalProductCount = shouldShowTotalProductCount({
    isDesktop,
    isMountedSortAndOneHrFilterRedesignEnabled,
    shouldHideLeftNavigation,
  });

  const { from, till } = getSelectedPageProductRange(
    recordsPerPage,
    currentPageNumber,
    selectedPageProductCount
  );

  const isFacetedNavigationNoIndexApplicableCheck = isFacetedNavigationNoIndexApplicable({
    isPLPFacetedNavigationEnabled,
    filterCount: appliedFilterIdsAndLength?.filterCount,
    appliedFilters,
    pathName,
  });
  return (
    <>
      {getSEOTags({
        pageId: CategoryListingPage.pageInfo.pageId,
        paginatedProducts,
        seoTitle,
        seoMetaDesc,
        canonicalUrl,
        router,
        genericCarouselData,
        isPLPCarouselEnabled,
        isPLPFacetedNavigationEnabled,
        appliedFilterIdsAndLength,
        totalProductsCount,
        appliedFilters,
        pathName,
        isNewSEOHreflangLinkEnabled,
        seoTokenList,
        currentPageNumber: getCurrentPageNumber(pageNumber),
        seoPageDirective,
      })}
      {renderBreadCrumbs({
        processedBreadCrumbs,
        isABTestForStickyFilter,
        totalProductsCount,
        hidePlpGridAndFilters,
        shouldHideLeftNavigation,
        from,
        till,
        showTotalProductCount,
      })}
      {checkOutfit && (
        <OutfitListingContainer
          asPath={outfitAsPath}
          navTree={navTree}
          getcategoryID={getcategoryID}
          pathName={pathName}
          longDescription={longDescription}
          onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
          outfitPath={outfitPath}
          processedBreadCrumbs={processedBreadCrumbs}
          cid={cid}
          currentCid={outfitAsPath}
          wishListData={wishListData}
          isShortImage={isShortImage}
          breadCrumbs={processedBreadCrumbs}
          onQuickViewOpenClick={onQuickViewOpenClick}
          onAddItemToFavorites={handleonAddItemToFavorites}
          trackWishListClick={trackWishListClick}
          isLoggedIn={isLoggedIn}
          isSyteEnabled={isSyteEnabled}
          router={router}
          trackPageLoadSearchRedirect={trackPageLoadSearchRedirect}
          seoHeaderCopy={seoHeaderCopy}
          isSeoHeaderCopyLoaded={isSeoHeaderCopyLoaded}
        />
      )}
      {isHorizontalPlpEnabled && !checkOutfit && (
        <HorizontalCategoryContainer
          cid={cid}
          pathName={pathName}
          wishListData={wishListData}
          isShortImage={isShortImage}
          breadCrumbs={processedBreadCrumbs}
          onQuickViewOpenClick={onQuickViewOpenClick}
          onAddItemToFavorites={handleonAddItemToFavorites}
          onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
          trackWishListClick={trackWishListClick}
          isLoggedIn={isLoggedIn}
          isSyteEnabled={isSyteEnabled}
          router={router}
          plpTopPromos={topPromosContent}
          dynamicPromoModules={dynamicPromoModules}
          longDescription={longDescription}
          sbcTypeValue={sbcTypeValue}
          setFromHplpFlag={setFromHplpFlag}
          trackPageLoadSearchRedirect={trackPageLoadSearchRedirect}
          promotionsData={promotionsData}
          seoHeaderCopy={seoHeaderCopy}
          isSeoHeaderCopyLoaded={isSeoHeaderCopyLoaded}
          shouldRenderSkeletonComponent={shouldRenderSkeletonComponent}
        />
      )}
      {isAlternatePlpEnabled && !checkOutfit && (
        <AlternatePLPCategoryContainer
          cid={cid}
          pathName={pathName}
          wishListData={wishListData}
          isShortImage={isShortImage}
          breadCrumbs={processedBreadCrumbs}
          onQuickViewOpenClick={onQuickViewOpenClick}
          onAddItemToFavorites={handleonAddItemToFavorites}
          onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
          trackWishListClick={trackWishListClick}
          isLoggedIn={isLoggedIn}
          isSyteEnabled={isSyteEnabled}
          router={router}
          plpTopPromos={topPromosContent}
          dynamicPromoModules={dynamicPromoModules}
          longDescription={longDescription}
          sbcTypeValue={sbcTypeValue}
          trackPageLoadSearchRedirect={trackPageLoadSearchRedirect}
          promotionsData={promotionsData}
          seoHeaderCopy={seoHeaderCopy}
          isSeoHeaderCopyLoaded={isSeoHeaderCopyLoaded}
          shouldRenderSkeletonComponent={shouldRenderSkeletonComponent}
        />
      )}
      {!isHorizontalPlpEnabled && !isAlternatePlpEnabled && !checkOutfit && (
        <PaginatedPageContainer
          pathName={pathName}
          wishListData={wishListData}
          isShortImage={isShortImage}
          processedBreadCrumbs={processedBreadCrumbs}
          onQuickViewOpenClick={onQuickViewOpenClick}
          onAddItemToFavorites={handleonAddItemToFavorites}
          onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
          promotionsData={promotionsData}
          trackClickPromotion={trackClickBundles}
          seoHeaderCopy={seoHeaderCopy}
          dynamicPromoModules={dynamicPromoModules}
          plpTopPromos={topPromosContent}
          categoryHasCMSPromoCombinations={categoryHasCMSPromoCombinations}
          trackWishListClick={trackWishListClick}
          isLoggedIn={isLoggedIn}
          isSyteEnabled={isSyteEnabled}
          router={router}
          isPLPCategoryPillsEnabled={isPLPCategoryPillsEnabled}
          addToBagEcom={addToBagEcom}
          isOneClickATCEnabled={isOneClickATCEnabled}
          sbcTypeValue={sbcTypeValue}
          setFromHplpFlag={setFromHplpFlag}
          isFromHplp={isFromHplp}
          trackPageLoadSearchRedirect={trackPageLoadSearchRedirect}
          favAddRemoveLoadingState={favAddRemoveLoadingState}
          isSeoHeaderCopyLoaded={isSeoHeaderCopyLoaded}
          shouldRenderSkeletonComponent={shouldRenderSkeletonComponent}
          isFacetedNavigationEnabled={isFacetedNavigationEnabled}
          appliedFilterIdsAndLength={appliedFilterIdsAndLength}
          isFacetedNavigationNoIndexApplicableCheck={isFacetedNavigationNoIndexApplicableCheck}
          hideFilters={hideFilters}
          setHideFilters={setHideFilters}
          isMountedHideLeftNavigationOnPLPEnabled={isMountedHideLeftNavigationOnPLPEnabled}
          shouldHideLeftNavigation={shouldHideLeftNavigation}
          isPLPSortAndOneHrFilterRedesignEnabled={isPLPSortAndOneHrFilterRedesignEnabled}
        />
      )}
      {isBundleTrackerEnabled && (
        <BundleTrackerContainer
          isTrackerOpen={isTrackerOpen}
          promotionsData={promotionsData}
          toggleTracker={toggleTrackerAction}
          trackClickBundles={trackClickBundles}
          isBundleTrackerEnabled={isBundleTrackerEnabled}
          trackPageLoadSearchRedirect={trackPageLoadSearchRedirect}
        />
      )}
      {hasMounted && <Syte />}
      <GlobalRtpsModal />
      <BackToTop />
    </>
  );
};

CategoryListingPage.pageInfo = {
  pageId: 'category',
};

CategoryListingPage.propTypes = ClpPropTypes;

CategoryListingPage.defaultProps = ClpDefaultProps;

const getModuleData = (moduleDataInState) => {
  const moduleData = isClient() ? moduleDataInState : {};
  return Object.keys(moduleData) || [];
};

// eslint-disable-next-line sonarjs/cognitive-complexity
async function fetchPromoCombinations(store, cid, res, isServer) {
  try {
    // Ensure store and cid are valid
    if (!store || !cid) {
      throw new Error('Invalid store or category ID');
    }

    const promoCombinations = store.getState().PromoCombinations;
    if (!promoCombinations || !promoCombinations[cid]) {
      const apiConfig = isServer ? res?.locals?.apiConfig ?? {} : getAPIConfig() ?? {};
      const { language } = apiConfig || {};

      const promoCombinationParams = {
        path: cid,
        brand: apiConfig?.brandIdCMS || '',
        channel: 'Desktop',
        country: apiConfig?.siteIdCMS || '',
        lang: language !== 'en' ? language : '',
      };

      const promoCombinationLayout = await PromoCombinationAbstractor.getPromoCombinationData(
        promoCombinationParams,
        apiConfig
      );

      if (!promoCombinationLayout) {
        throw new Error('Failed to fetch promo combination data');
      }

      const moduleDataInState = store.getState().Modules;
      const moduleData = getModuleData(moduleDataInState);
      const { layout, moduleObjects, promoCombinationContentID } =
        await instanceProductListing.parsedModuleData(
          promoCombinationLayout,
          getAPIConfig(),
          moduleData,
          true
        );

      store.dispatch(
        loadPromoCombinationData(
          {
            ...layout,
            isCompleted: true,
            hasTopPromos: layout?.top?.length > 0,
            contentId: promoCombinationContentID,
          },
          cid
        )
      );

      let modules = {};
      if (moduleObjects.length) {
        modules = await instanceProductListing.moduleResolver(moduleObjects, apiConfig);
      }

      if (!layout || !modules) {
        throw new Error('Failed to parse module data');
      }

      store.dispatch(loadModulesData(modules));
    }
  } catch (error) {
    store.dispatch(loadPromoCombinationData({ isCompleted: true }, cid));
    console.error('Error fetching promo combinations:', error);
  }
}

function executeWithTimeout(promiseFunc, timeout) {
  return Promise.race([
    promiseFunc(),
    new Promise((resolve) =>
      setTimeout(() => {
        resolve('Continued asynchronously');
      }, timeout)
    ),
  ]);
}

const calculatePromoCid = (cid) => {
  return cid && typeof cid === 'string' ? cid.split('/')[0] || null : null;
};

const getPathName = (bootstrapPayload, path, pathname, asPath) => {
  return (bootstrapPayload?.apiConfig?.isSeoFacetedNavigationEnabled ? path : pathname) || asPath;
};

const getIsEnableCMSPromos = (isServer, res) => {
  return isServer
    ? parseBoolean(res?.locals?.apiConfig?.enableCMSPromos) ?? false
    : parseBoolean(getAPIConfig()?.enableCMSPromos) ?? false;
};

CategoryListingPage.getInitialProps = async ({
  isServer,
  asPath,
  req,
  store,
  query: { cid } = {},
  bootstrapPayload = {},
  res,
}) => {
  // eslint-disable-next-line no-underscore-dangle
  const { path = '', pathname = '' } = req?._parsedUrl || {};
  const pathName = getPathName(bootstrapPayload, path, pathname, asPath);
  let isInitialCall = false;

  const enableCMSPromos = getIsEnableCMSPromos(isServer, res);

  const asyncTimeoutPromoCombination = isServer
    ? res?.locals?.apiConfig?.asyncTimeoutPromoCombination ?? 0
    : getAPIConfig()?.asyncTimeoutPromoCombination ?? 0;

  let promoCid = cid;

  if (!isServer) {
    promoCid = calculatePromoCid(cid);
  }

  if (enableCMSPromos && isServer) {
    // Await fetchPromoCombinations without a timeout
    await fetchPromoCombinations(store, promoCid, res, isServer);
  }

  if (enableCMSPromos && isClient()) {
    await executeWithTimeout(
      () => fetchPromoCombinations(store, promoCid, res, isServer),
      asyncTimeoutPromoCombination
    );
  }

  if (isServer) {
    const { apiConfig = {}, apiConfig: { firstLoadPLPProductCount = 30 } = {} } = res?.locals || {};
    isInitialCall = true;
    const isValidCategory = await new Promise((resolve) => {
      return store.dispatch(
        getCategoryBasedProducts({
          cid,
          pathName,
          isInitialCall,
          isServer: true,
          recordsPerPage: parseInt(firstLoadPLPProductCount, 10),
          currentPageNumber: 1,
          bootstrapPayload: { payload: { ...bootstrapPayload, headers: { ...req.headers } } },
          resolve,
          skipCategoryCall: !getIsValidUrl({
            pathName,
          }),
        })
      );
    });

    if (!isValidCategory) {
      res.statusCode = 404;
      return {};
    }
    const payload = {
      apiConfig,
      page: cid,
      isCategoryPage: true,
    };
    store.dispatch(getSEOTokenJSON());
    store.dispatch(loadCategoryPageSeoData({ module: SEO_DATA.categorySeoData, ...payload }));
  }

  return { pathName, isInitialCall };
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoryListingPage);
